{{#if isPipelined}}
virtual function {{ sequenceItem.type }} get_transaction(logic [{{ interface.idMsbParameter.name }}:0] id);
  if (!{{ activeTransactionsVariable.identifier }}.exists(id)) begin
    `uvm_fatal(get_type_name(), $sformatf("No active transaction with id='h%x.", id))
  end
  return {{ activeTransactionsVariable.identifier }}[id];
endfunction
{{/if}}
